module.exports = "/_next/static/images/stream-is-down-589a3006a7c6deea182c20c32c0f216a.svg";